import { getApp } from "@firebase/app";
import {
  connectStorageEmulator,
  getDownloadURL,
  getMetadata,
  getStorage,
  ref,
  uploadBytes,
} from "firebase/storage";
const switchBucket = (bucketName) => {
  if (process.env.REACT_APP_STAGING === "local") {
    connectStorageEmulator(getStorage(getApp(), bucketName), "localhost", 9199);
  }
  return getStorage(getApp(), bucketName);
};

export async function getFileUrl(storageLocation) {
  const slashElementIndex = storageLocation.indexOf("/", 12);
  const fileName = storageLocation.substring(
    slashElementIndex + 1,
    storageLocation.length
  );
  const bucketName = storageLocation.substring(0, slashElementIndex);
  const customStorage = switchBucket(bucketName);
  const fileRef = ref(customStorage, fileName);
  const url = await getDownloadURL(fileRef);
  const metaData = await getMetadata(fileRef);

  return { url: url, type: metaData.contentType.split("/")[0] };
}

export async function uploadCompliantProof(
  file,
  complaintId,
  locationId,
  type
) {
  const customStorage = switchBucket(process.env.REACT_APP_DEFAULT_BUCKET);

  await uploadBytes(
    ref(
      customStorage,
      `/${locationId}/complaints/${complaintId}/closure/${file?.name}`
    ),
    file
  );
}

export async function uploadToBucket(filePath, file) {
  const customStorage = switchBucket(process.env.REACT_APP_DEFAULT_BUCKET);
  await uploadBytes(ref(customStorage, filePath), file);
  return `${customStorage._url}${filePath}`;
}
